import { atom } from 'jotai'

export const sitesName = atom<string>('')
export const interfaceName = atom<any>('')
